import type { ComponentProps } from "react"
import { forwardRef } from "react"

import { cn } from "@productlane/lib/src/browser"

type Props = ComponentProps<"svg">

export const SlackIcon = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 28 28"
				ref={ref}
				{...props}
				className={cn("", className)}
			>
				<path
					d="M6.38821 17.3655C6.38821 18.8789 5.15188 20.1153 3.63844 20.1153C2.125 20.1153 0.888672 18.8789 0.888672 17.3655C0.888672 15.8521 2.125 14.6157 3.63844 14.6157H6.38821V17.3655Z"
					fill="#E01E5A"
				/>
				<path
					d="M7.77344 17.3655C7.77344 15.8521 9.00977 14.6157 10.5232 14.6157C12.0366 14.6157 13.273 15.8521 13.273 17.3655V24.2506C13.273 25.764 12.0366 27.0003 10.5232 27.0003C9.00977 27.0003 7.77344 25.764 7.77344 24.2506V17.3655Z"
					fill="#E01E5A"
				/>
				<path
					d="M10.5232 6.38772C9.00977 6.38772 7.77344 5.15139 7.77344 3.63795C7.77344 2.12451 9.00977 0.888184 10.5232 0.888184C12.0366 0.888184 13.273 2.12451 13.273 3.63795V6.38772H10.5232Z"
					fill="#36C5F0"
				/>
				<path
					d="M10.5235 7.77319C12.037 7.77319 13.2733 9.00952 13.2733 10.523C13.2733 12.0364 12.037 13.2727 10.5235 13.2727H3.63844C2.125 13.2727 0.888672 12.0364 0.888672 10.523C0.888672 9.00952 2.125 7.77319 3.63844 7.77319H10.5235Z"
					fill="#36C5F0"
				/>
				<path
					d="M21.502 10.523C21.502 9.00952 22.7383 7.77319 24.2517 7.77319C25.7652 7.77319 27.0015 9.00952 27.0015 10.523C27.0015 12.0364 25.7652 13.2727 24.2517 13.2727H21.502V10.523Z"
					fill="#2EB67D"
				/>
				<path
					d="M20.1167 10.523C20.1167 12.0365 18.8804 13.2728 17.367 13.2728C15.8535 13.2728 14.6172 12.0365 14.6172 10.523V3.63795C14.6172 2.12451 15.8535 0.888184 17.367 0.888184C18.8804 0.888184 20.1167 2.12451 20.1167 3.63795V10.523Z"
					fill="#2EB67D"
				/>
				<path
					d="M17.367 21.5007C18.8804 21.5007 20.1167 22.7371 20.1167 24.2505C20.1167 25.7639 18.8804 27.0003 17.367 27.0003C15.8535 27.0003 14.6172 25.7639 14.6172 24.2505V21.5007H17.367Z"
					fill="#ECB22E"
				/>
				<path
					d="M17.367 20.1153C15.8535 20.1153 14.6172 18.8789 14.6172 17.3655C14.6172 15.8521 15.8535 14.6157 17.367 14.6157H24.252C25.7655 14.6157 27.0018 15.8521 27.0018 17.3655C27.0018 18.8789 25.7655 20.1153 24.252 20.1153H17.367Z"
					fill="#ECB22E"
				/>
			</svg>
		)
	},
)

export const SlackIconGray = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 28 28"
				ref={ref}
				{...props}
				className={cn("", className)}
			>
				<path
					d="M6.38821 17.3655C6.38821 18.8789 5.15188 20.1153 3.63844 20.1153C2.125 20.1153 0.888672 18.8789 0.888672 17.3655C0.888672 15.8521 2.125 14.6157 3.63844 14.6157H6.38821V17.3655Z"
					fill="currentColor"
				/>
				<path
					d="M7.77344 17.3655C7.77344 15.8521 9.00977 14.6157 10.5232 14.6157C12.0366 14.6157 13.273 15.8521 13.273 17.3655V24.2506C13.273 25.764 12.0366 27.0003 10.5232 27.0003C9.00977 27.0003 7.77344 25.764 7.77344 24.2506V17.3655Z"
					fill="currentColor"
				/>
				<path
					d="M10.5232 6.38772C9.00977 6.38772 7.77344 5.15139 7.77344 3.63795C7.77344 2.12451 9.00977 0.888184 10.5232 0.888184C12.0366 0.888184 13.273 2.12451 13.273 3.63795V6.38772H10.5232Z"
					fill="currentColor"
				/>
				<path
					d="M10.5235 7.77319C12.037 7.77319 13.2733 9.00952 13.2733 10.523C13.2733 12.0364 12.037 13.2727 10.5235 13.2727H3.63844C2.125 13.2727 0.888672 12.0364 0.888672 10.523C0.888672 9.00952 2.125 7.77319 3.63844 7.77319H10.5235Z"
					fill="currentColor"
				/>
				<path
					d="M21.502 10.523C21.502 9.00952 22.7383 7.77319 24.2517 7.77319C25.7652 7.77319 27.0015 9.00952 27.0015 10.523C27.0015 12.0364 25.7652 13.2727 24.2517 13.2727H21.502V10.523Z"
					fill="currentColor"
				/>
				<path
					d="M20.1167 10.523C20.1167 12.0365 18.8804 13.2728 17.367 13.2728C15.8535 13.2728 14.6172 12.0365 14.6172 10.523V3.63795C14.6172 2.12451 15.8535 0.888184 17.367 0.888184C18.8804 0.888184 20.1167 2.12451 20.1167 3.63795V10.523Z"
					fill="currentColor"
				/>
				<path
					d="M17.367 21.5007C18.8804 21.5007 20.1167 22.7371 20.1167 24.2505C20.1167 25.7639 18.8804 27.0003 17.367 27.0003C15.8535 27.0003 14.6172 25.7639 14.6172 24.2505V21.5007H17.367Z"
					fill="currentColor"
				/>
				<path
					d="M17.367 20.1153C15.8535 20.1153 14.6172 18.8789 14.6172 17.3655C14.6172 15.8521 15.8535 14.6157 17.367 14.6157H24.252C25.7655 14.6157 27.0018 15.8521 27.0018 17.3655C27.0018 18.8789 25.7655 20.1153 24.252 20.1153H17.367Z"
					fill="currentColor"
				/>
			</svg>
		)
	},
)
